<template>
  <div
    ref="container"
    class="container"
    :class="{ 'container--extended': extended }"
  >
    <label class="wrapper">
      <input
        ref="input"
        v-model="internalValue"
        :value="value"
        required
        :disabled="loading"
        type="checkbox"
        class="checkbox-el"
        @change="handleChange"
      />

      <span
        ref="label-extended"
        class="label label--extended"
        :class="{ 'label--disabled': loading }"
      >
        <span class="span span--extended">
          Zapoznałam/łem się z treścią informacji o zasadach przetwarzania
          danych osobowych.
          <br /><br />
          <ol>
            <li>
              <strong
                >Administratorem danych osobowych jest GRUPA ŻYWIEC Sp. z o.o.
                z&nbsp;siedzibą w&nbsp;Żywcu, przy ul. Browarnej 88, 34-300
                Żywiec</strong
              >, zwana dalej Administratorem.
            </li>
            <li>
              <strong>Kontakt z Administratorem danych</strong> jest możliwy
              poprzez adres e-mail
              <a href="mailto:dane.osobowe@grupazywiec.pl"
                >dane.osobowe@grupazywiec.pl</a
              >
              lub z&nbsp;wykorzystaniem wyżej wskazanego adres
              korespondencyjnego.
            </li>
            <li>
              <strong>Cel i podstawa przetwarzania danych:</strong>
              <ol>
                <li>
                  Udzielenie odpowiedzi na skierowaną poprzez formularz
                  kontaktowy wiadomość (pytanie, wniosek)– podstawą
                  przetwarzania jest zgoda osoby (art. 6. ust. 1. lit. a RODO),
                  rozumiana jako skierowanie do Administratora wiadomości z
                  oczekiwaniem udzielenia na nią odpowiedzi.
                </li>
                <li>
                  Statystycznych i analitycznych, w tym profilowania– podstawą
                  przetwarzania jest realizacja prawnie uzasadnionego interesu
                  Administratora, polegającego na możliwości tworzenia statystyk
                  i analiz wewnętrznych (art. 6. ust. 1. lit. f) RODO).
                </li>
                <li>
                  Badanie satysfakcji z jakości usług lub produktów
                  Administratora – podstawą przetwarzania jest prawnie
                  uzasadniony interes Administratora, polegający na podnoszeniu
                  jakości oferowanych produktów i usług (art. 6. ust. 1 lit. f)
                  RODO).
                </li>
                <li>
                  Ustalenie i dochodzenie roszczeń oraz obrona przed
                  roszczeniami – podstawą przetwarzania jest realizacja prawnie
                  uzasadnionego interesu Administratora, którym jest możliwość
                  dochodzenia roszczeń lub obrony przed nimi (art. 6 ust. 1 lit.
                  f RODO) w zw. z przepisami ustawy z dnia 23 kwietnia
                  1964&nbsp;r. Kodeks cywilny).
                </li>
              </ol>
            </li>
            <li>
              <strong>Kto otrzyma dane:</strong> spółki z grupy kapitałowej
              Żywiec, podmioty przetwarzające dane osobowe na zlecenie
              Administratora i zgodnie z jego wytycznymi m.in. dostawcy usług
              informatycznych, a także podmioty lub organy uprawnione do
              otrzymania danych osobowych na podstawie obowiązujących przepisów
              prawa.
            </li>
            <li>
              <strong>Okres przechowywania danych:</strong> W zależności od
              podstawy prawnej dane będą przetwarzane do czasu wycofania zgody,
              realizacji prawnie uzasadnionego interesu Administratora lub
              zgłoszenia sprzeciwu wobec przetwarzania opartego na prawnie
              uzasadnionym interesie.
            </li>
            <li>
              <strong>Przysługujące prawa:</strong>
              <ol>
                <li>Dostępu do danych</li>
                <li>Sprostowania danych</li>
                <li>Usunięcia danych</li>
                <li>Ograniczenia przetwarzania</li>
                <li>
                  Sprzeciwu, względem przetwarzania którego podstawą jest
                  prawnie uzasadniony interes Administratora
                </li>
                <li>Wycofania zgody</li>
                <li>Przenoszenia danych</li>
                <li>
                  Wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych
                </li>
              </ol>
              <strong>
                Jak skorzystać z przysługujących praw?
              </strong>
              <br />
              W przypadku praw wskazanych w pkt. 6.1-6.6 należy złożyć wniosek.
              Dane kontaktowe znajdują się w punkcie 1. i 2. W przypadku prawa
              wskazanego w pkt. 6.7 należy skontaktować się z Urzędem Ochrony
              Danych Osobowych.
            </li>
            <li>
              <strong>Podanie danych jest dobrowolne</strong> niemniej jest
              warunkiem otrzymania odpowiedzi na skierowaną wiadomość.
            </li>
            <li>
              Dane nie będą podlegały zautomatyzowanemu podejmowaniu decyzji.
            </li>
            <li>
              Dane nie będą przekazywane do państw trzecich, poza Europejski
              Obszar Gospodarczy.
            </li>
          </ol>
        </span>

        <div ref="overlay" class="overlay" />

        <button
          class="button button--extended"
          @click.prevent="$emit('toggleAgreement', false)"
          v-text="'Zwiń'"
        />
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Boolean, Array],
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    extended: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      heightToScroll: 0,
      internalValue: false,
      isAgreementExtended: false
    }
  },
  computed: {
    error() {
      return this.errors[0] ? this.errors[0] : ''
    }
  },
  watch: {
    value: {
      handler(value) {
        this.internalValue = value
      },
      immediate: true
    }
  },
  methods: {
    handleChange() {
      this.$refs.input.blur()
      this.$emit('change')
      this.$emit('input', this.internalValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  &--extended {
    @include fill-space;
    background-color: $background-color;
    opacity: 0;
  }
}

.wrapper {
  display: block;
  width: 100%;

  background-color: $background-color;

  @include media-down(lg) {
    padding-bottom: 50px;
  }
  @include media-down(md) {
    padding-bottom: 20px;
  }
}

.checkbox-el {
  @include checkbox-el;
}

.label {
  @include checkbox-label;
}

.button {
  @include extend-button;

  margin: 8px 0 16px;

  &--extended {
    &::after {
      height: 1px;
      width: 37px;

      @include media-down(xl) {
        width: 31px;
      }
      @include media-down(lg) {
        width: 43px;
      }
      @include media-down(md) {
        width: 37px;
      }
    }
  }
}

.span {
  @include checkbox-span;
}

.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 81%;

  transform: scaleY(0);
  transform-origin: center bottom;
  background-color: $background-color;
  z-index: z(checkbox-extended);

  @include media-down(lg) {
    height: 100%;
    left: 30px;
    width: calc(100% - 30px);
  }
}
</style>
